import React from 'react';
import AuthModal from './AuthModal';
import { Button, Checkbox, Form, Input, notification } from 'antd';
import { UserIcon } from '../Icons';
import { OrionIcon, TextButton } from '../common';
import background from '../../assets/sign-up.png';
import { AuthModalProps, ButtonWrapper, FormWrapper, HelpText, ModalTitle, SignInForm } from './common';
import { useAppDispatch } from '../../store';
import { setSignIn, setSignUp } from '../../store/modal.slice';
import { RegisterRequest } from '../../api/user';
import useAuth from '../../hooks/use-auth';

const SignUpModal = (props: AuthModalProps) => {
    const dispatch = useAppDispatch();
    const { register, userLoading } = useAuth();

    const signIn = () => {
        dispatch(setSignUp(false));
        dispatch(setSignIn(true));
    };

    const createAccount = async (data: RegisterRequest) => {
        try {
            await register(data);
            props.onAuth();
            dispatch(setSignUp(false));
        } catch (e: any) {
            notification.error({
                message: 'Error signing up!',
                description: e?.toString?.() ?? 'Unknown error'
            });
        }
    };

    return (
        <AuthModal
            footer={null}
            {...props}
            graphicTitle="Create an Account."
            graphicSubtitle="Sign up and participate in the Aleo Setup."
            background={background}
            closable
        >
            <ModalTitle>Sign Up</ModalTitle>

            <SignInForm onFinish={createAccount as any}>
                <FormWrapper>
                    <Form.Item name="username" rules={[{ required: true, message: 'Username is required!' }]}>
                        <Input placeholder="Username" prefix={<UserIcon style={{ width: 18 }} />} size="large" />
                    </Form.Item>

                    <Form.Item name="email" rules={[{ required: true, message: 'Email is required!' }]}>
                        <Input
                            placeholder="Email"
                            type="email"
                            prefix={<OrionIcon icon="mail" fontSize={16} />}
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item name="password" rules={[{ required: true, message: 'Password is required!' }]}>
                        <Input
                            placeholder="Password"
                            type="password"
                            prefix={<OrionIcon icon="lock" fontSize={16} />}
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        name="confirm_password"
                        rules={[{ required: true, message: 'Please confirm your password!' }]}
                    >
                        <Input
                            placeholder="Confirm Password"
                            type="password"
                            prefix={<OrionIcon icon="lock" fontSize={16} />}
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item name="terms_conditions" valuePropName="checked">
                        <Checkbox>
                            I have read and agree to the <TextButton>Terms and Conditions</TextButton>.
                        </Checkbox>
                    </Form.Item>
                </FormWrapper>

                <Form.Item style={{ marginBottom: 0 }}>
                    <ButtonWrapper>
                        <Button type="primary" size="large" htmlType="submit" loading={userLoading}>
                            Create Account
                        </Button>
                    </ButtonWrapper>

                    <HelpText>
                        Already have an account? <TextButton onClick={signIn}>Sign in here</TextButton>.
                    </HelpText>
                </Form.Item>
            </SignInForm>
        </AuthModal>
    );
};

export default SignUpModal;
